<template>
  <div class="home">

    <div class="wap_nav wap">
      <div class="mobile">
        <div class="mobile-inner">
          <div class="mobile-inner-header">
            <div class="logo"><a href="#"> <img src="images/logo.png" alt=""> </a></div>
            <div class="mobile-inner-header-icon mobile-inner-header-icon-out"><span></span><span></span></div>
          </div>
          <div class="mobile-inner-nav">
            <ul>
              <li>
                <h2 class="h2tit">
                  <a href="#">Token Introduction</a>
                </h2>
              </li>
              <li>
                <h2 class="h2tit">
                  <a href="#">RWA</a>
                </h2>
              </li>
              <li>
                <h2 class="h2tit">
                  <a href="#">Roadmap</a>
                </h2>
              </li>
              <li>
                <h2 class="h2tit">
                  <a href="#">Partners</a>
                </h2>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>


    <div class="head ">
      <div class="wrap">
        <div class="logo pc">
          <a href="#">
            <img src="images/logo.png" alt="">
          </a>
        </div>
        <div class="nav pc">
          <ul>
            <li>
              <h2 class="h2tit">
                <a href="#">{{ $t('tokenIntroduction') }}</a>
              </h2>
            </li>
            <li>
              <h2 class="h2tit">
                <a href="#mint">{{ $t('mint') }}</a>
              </h2>
            </li>
            <li>
              <h2 class="h2tit">
                <a href="#">{{ $t('roadmap') }}</a>
              </h2>
            </li>
            <li>
              <h2 class="h2tit">
                <a href="#">{{ $t('partners') }}</a>
              </h2>
            </li>
          </ul>
        </div>
        <div class="right">
          <div class="lan">
            <h2 class="h2tit">{{ $t('language') }}</h2>
            <dl>
              <dd><a href="javascript:" @click="switchLanguage('en')">English</a></dd>
              <dd><a href="javascript:" @click="switchLanguage('ru')">Russian</a></dd>
              <dd><a href="javascript:" @click="switchLanguage('tr')">Turkish</a></dd>
            </dl>
          </div>
          <div class="link">
            <a href="https://x.com/beginonkas" target="_blank"><img src="images/lis1.png" alt=""></a>
            <a href="https://t.me/beginonkaspa" target="_blank"><img src="images/lis2.png" alt=""></a>
          </div>
          <a href="#mint" class="mint">{{ $t('mint') }}</a>
        </div>
      </div>
    </div>

    <div class="index ">
      <div class="section1 wow fadeInUp ">
        <div class="title">{{ $t('WelcometoBGIN') }}</div>
        <div class="title2"><img src="images/bt@2x.png" alt=""></div>
        <div class="content">
          <div class="left"><img src="images/t1.png" alt="" class="scrollAni3"></div>
          <div class="right">
            <div class="icon"><img src="images/t2.png" alt="" class="scrollAni4"></div>
            <div class="title3">{{ $t('whatsBGIN') }}</div>
            <div class="dec">{{ $t('bginDescription') }}
            </div>
          </div>
          <div class="mouse">
            <img src="images/mouse.png" alt="" class="moveAni">
          </div>
          <div class="dot"><img src="images/dot.png" alt=""></div>
        </div>
      </div>
      <div class="section2 wow fadeInUp " id="mint">
        <div class="content">
          <div class="icon"><img src="images/t3.png" alt="" class="pfAni1"></div>
          <div class="title">{{ $t('eligibilityCheck') }}</div>
          <div class="line">
            <i :style="mintProcessStyle">
              <span class="val">{{ mintProcess }}%</span>
            </i>
          </div>
          <div class="btns">
<!--            <button type="button" @click="onClickMint1">{{ $t('mintKSPR') }}</button>-->
            <!--            <button type="button" @click="onClickMint2">{{ $t('mintKnot') }}</button>-->
          </div>
        </div>
      </div>
      <div class="section3 wow fadeInUp ">
        <div class="title">{{ $t('whyBGIN') }}</div>
        <div class="list">
          <div class="item">
            <div class="icon"><img src="images/ic1.png" alt=""></div>
            <div class="tit">{{ $t('communityDriven') }}</div>
            <div class="dec"> {{ $t('buildingFuture') }}</div>
          </div>
          <div class="item">
            <div class="icon"><img src="images/ic2.png" alt=""></div>
            <div class="tit">{{ $t('kaspaBlockchain') }}</div>
            <div class="dec">{{ $t('fastestPoW') }}</div>
          </div>
          <div class="item">
            <div class="icon"><img src="images/ic3.png" alt=""></div>
            <div class="tit">{{ $t('rwaTokenization') }}</div>
            <div class="dec">{{ $t('realStuff') }}</div>
          </div>
          <div class="item">
            <div class="icon"><img src="images/ic4.png" alt=""></div>
            <div class="tit">{{ $t('memesImpact') }}</div>
            <div class="dec">{{ $t('seriousStuff') }}</div>
          </div>
        </div>
      </div>
      <div class="section4 wow fadeInUp ">
        <div class="title">BGIN Token – <br>{{ $t('MoreThan') }}</div>
        <div class="content">
          <div class="left"><img src="images/t4.png" alt="" class="scrollAni3"></div>
          <div class="right">
            <div class="item">
              <div class="tit">{{ $t('governanceToken') }}</div>
              <div class="dec">{{ $t('shapeFuture') }}</div>
            </div>
            <div class="item">
              <div class="tit">{{ $t('fairLaunch') }}</div>
              <div class="dec">{{ $t('noPreMining') }}</div>
            </div>
            <div class="item">
              <div class="tit">{{ $t('billionTokens') }}</div>
              <div class="dec">{{ $t('getYours') }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="section5 wow fadeInUp ">
        <div class="title">KRC-20 <br> {{ $t('krc20') }}</div>
        <div class="content">
          {{ $t('krc20Description') }}
          <div class="icon"><img src="images/t5.png" alt=""></div>
        </div>
      </div>
      <div class="section6 wow fadeInUp ">
        <div class="title">{{ $t('roadmapTitle') }}</div>
        <div class="dec"> {{ $t('bginJourney') }}</div>
        <div class="list">
          <div class="item">
            <div class="title2">{{ $t('phase1') }}</div>
            <div class="title3">{{ $t('phase1_1') }}</div>
            <div class="desc">{{ $t('phase1Desc') }}</div>
          </div>
          <div class="item">
            <div class="title2">{{ $t('phase2') }}</div>
            <div class="title3">{{ $t('phase2_1') }}</div>
            <div class="desc">{{ $t('phase2Desc') }}</div>
          </div>
          <div class="item">
            <div class="title2">{{ $t('phase3') }}</div>
            <div class="title3">{{ $t('phase3_1') }}</div>
            <div class="desc">{{ $t('phase3Desc') }}</div>
          </div>
          <div class="item">
            <div class="title2">{{ $t('phase4') }}</div>
            <div class="title3">{{ $t('phase4_1') }}</div>
            <div class="desc">{{ $t('phase4Desc') }}</div>
          </div>
        </div>
      </div>
      <div class="section7 wow fadeInUp ">
        <div class="left">
          <div class="title">{{ $t('getIn') }}</div>
          <div class="list">
            <div class="item">
              <div class="num"><img src="images/1.png" alt=""></div>
              <div class="ris">
                <div class="title2">{{ $t('joinCommunity') }}</div>
                <div class="dec">{{ $t('innovationFinance') }}</div>
              </div>
            </div>
            <div class="item">
              <div class="num"><img src="images/2.png" alt=""></div>
              <div class="ris">
                <div class="title2">{{ $t('noFOMO') }}</div>
                <div class="dec">{{ $t('revolutionStarting') }}}</div>
              </div>
            </div>
            <div class="item">
              <div class="num"><img src="images/3.png" alt=""></div>
              <div class="ris">
                <div class="title2">{{ $t('secureTokens') }}</div>
                <div class="dec">{{ $t('bginReady') }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <img src="images/t9.png" alt="" class="scrollAni6">
        </div>
      </div>
      <div class="section8 wow fadeInUp ">
        <p>
          {{ $t('bginCoin') }}
        </p>
        <p>
          {{ $t('getInBgin') }}
        </p>
      </div>
    </div>

    <div class="footer">
      <div class="con1">
        <div class="left">
          <div class="logo">
            <img src="images/logo2.png" alt="">
          </div>
          <a href="https://x.com/beginonkas" target="_blank">
            <img src="images/li1.png" alt="">
          </a>
          <a href="https://t.me/beginonkaspa" target="_blank">
            <img src="images/li2.png" alt="">
          </a>
        </div>
        <div class="right">
          <a href="https://x.com/beginonkas" target="_blank">{{ $t('FollowUsonTwitter') }}</a>
          <a href="https://t.me/beginonkaspa" target="">{{ $t('FollowUsonTelegram') }}</a>
        </div>
      </div>
      <div class="con2" style="font-size: calc(16/1920*100vw)">
        {{ $t('Disclaimer') }}
      </div>
    </div>


  </div>
</template>

<script>
import WOW from 'wow.js';

export default {
  name: 'HomeView',
  components: {},
  data() {
    return {
      data: {
        "ticker": "BGIN",
        "maxSupply": 100000000000000000,
        "preMint": 0,
        "mintLimit": 100000000000,
        "decimal": 8,
        "totalMinted": 4500000000000,
        "opScoreCreated": 1054808060000,
        "opScoreUpdated": 1054978850000,
        "deployedAt": 1741772980169,
        "status": "deployed",
        "revealHash": "c135cfd78b9e4c5eaf0b3448265a91958ba081e7eebdebf14e0f3bf60fc3484d",
        "holderTotal": 1,
        "transferTotal": 0,
        "mintTotal": 45,
        "deployerAddress": "kaspa:qqg6a2mmshvxv8csdu904ueegz0tedn9lntyc09e33w69e226zvhw7e8t9m23",
        "holders": [
          {
            "address": "kaspa:qp7ynf9tjdtth62rtkrtws5vpyf633mku822zx592m7uve7tsy6uxctemrqvt",
            "amount": 4500000000000,
            "tags": []
          }
        ],
        "priceHistory": [],
        "priceCandles": [],
        "tradeVolume": {
          "amountInUsd": 0
        },
        "socialLinks": [],
        "iconUrl": "https://krc20-assets.kas.fyi/icons/BGIN.jpg",
        "marketsData": [],
        "burned": 0,
        "tradeEnabled": false
      }
    }
  },
  computed: {
    mintProcess() {
      if (this.data.totalMinted < this.data.maxSupply) {
        let res = ( this.data.totalMinted) / this.data.maxSupply * 100
        return res.toFixed(2)
      } else {
        return 100
      }
    },
    mintProcessStyle() {
      return "width:" + this.mintProcess + "%";
    }
  },
  methods: {
    switchLanguage(lang) {
      this.$i18n.locale = lang;
    },
    onClickMint1() {
      const url = 'https://t.me/kspr_home_bot?start=WdRcvw'
      window.open(url)
    },
    async load() {
      const url = "https://api-v2-do.kas.fyi/token/krc20/BGIN/info";
      const response = await fetch(url);
      const data = await response.json();
      console.log(data)
      this.data = data;
      console.log("this.data.totalMinted ", this.data.totalMinted)
      console.log("this.data.mintLimit ", this.data.mintLimit)
    }
    // onClickMint2(){
    //   const url = 'https://t.me/kspr_home_bot?start=WdRcvw'
    //   window.open(url)
    // }
  },
  mounted() {
    const wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true,
      // scrollContainer:null,
      // resetAnimation:true
    })
    wow.init()
    this.load()

    setInterval(() => {
      this.load()
    }, 1000 * 10)
    // new WOW().init(); // 初始化 Wow.js
  }
}
</script>
